import {Button} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import {css} from "@emotion/css";

const ButtonSimpleIcon = ({className, onClick, iconClass = "share-link-icon"}) => {
    return (
        <button
            onClick={onClick}
            className={`btnAccess ${iconClass} ${css`
              &:hover {
                background-color: var(--color-primary);
              }

            `}`}/>
    )
}

export default ButtonSimpleIcon;

ButtonSimpleIcon.propTypes = {
    iconClass: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string
}